<div class="date-picker-card" [class.date-picker-card--multiple]="mode === 'multiple'">
  <ng-container *ngIf="mode === 'multiple'; else singleCal">
    <div class="dp-calendars">
      <section class="dp-calendar">
        <div class="dp-header">
          <button type="button" class="dp-nav" aria-label="Previous month" (click)="prevMonth('left')">
            <i class="bi bi-chevron-left" aria-hidden="true"></i>
          </button>
          <ng-container *ngTemplateOutlet="monthYearJump; context: { month: displayMonth, year: displayYear, side: 'left' }"></ng-container>
          <button type="button" class="dp-nav" aria-label="Next month" (click)="nextMonth('left')">
            <i class="bi bi-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
        <ng-container *ngTemplateOutlet="monthBody; context: { weeks: weeks }"></ng-container>
      </section>

      <section class="dp-calendar">
        <div class="dp-header">
          <button type="button" class="dp-nav" aria-label="Previous month" (click)="prevMonth('right')">
            <i class="bi bi-chevron-left" aria-hidden="true"></i>
          </button>
          <ng-container *ngTemplateOutlet="monthYearJump; context: { month: adjacentMonth.month, year: adjacentMonth.year, side: 'right' }"></ng-container>
          <button type="button" class="dp-nav" aria-label="Next month" (click)="nextMonth('right')">
            <i class="bi bi-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
        <ng-container *ngTemplateOutlet="monthBody; context: { weeks: adjacentWeeks }"></ng-container>
      </section>
    </div>
  </ng-container>

  <ng-template #singleCal>
    <div class="dp-header">
      <button type="button" class="dp-nav" aria-label="Previous month" (click)="prevMonth()">
        <i class="bi bi-chevron-left" aria-hidden="true"></i>
      </button>
      <ng-container *ngTemplateOutlet="monthYearJump; context: { month: displayMonth, year: displayYear, side: 'left' }"></ng-container>
      <button type="button" class="dp-nav" aria-label="Next month" (click)="nextMonth()">
        <i class="bi bi-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
    <ng-container *ngTemplateOutlet="monthBody; context: { weeks: weeks }"></ng-container>
  </ng-template>

  <ng-template #monthYearJump let-month="month" let-year="year" let-side="side">
    <div class="dp-jump">
      <div class="dp-jump-wrap">
        <button
          type="button"
          class="dp-jump-btn"
          [class.dp-jump-btn--open]="isJumpOpen('month', side)"
          [attr.aria-expanded]="isJumpOpen('month', side)"
          aria-haspopup="listbox"
          [attr.aria-label]="'Select month, ' + monthName(month)"
          (click)="toggleJump('month', side)"
        >
          {{ monthName(month) }}
          <i class="bi bi-chevron-down" aria-hidden="true"></i>
        </button>
        <div class="dp-jump-menu dp-jump-menu--months" *ngIf="isJumpOpen('month', side)" role="listbox">
          <button
            type="button"
            class="dp-jump-option"
            *ngFor="let m of monthOptions"
            role="option"
            [attr.aria-selected]="m.value === month"
            [class.dp-jump-option--active]="m.value === month"
            [disabled]="isMonthDisabled(m.value, year)"
            (click)="pickMonth(m.value, side)"
          >
            {{ m.short }}
          </button>
        </div>
      </div>
      <div class="dp-jump-wrap">
        <button
          type="button"
          class="dp-jump-btn"
          [class.dp-jump-btn--open]="isJumpOpen('year', side)"
          [attr.aria-expanded]="isJumpOpen('year', side)"
          aria-haspopup="listbox"
          [attr.aria-label]="'Select year, ' + year"
          (click)="toggleJump('year', side)"
        >
          {{ year }}
          <i class="bi bi-chevron-down" aria-hidden="true"></i>
        </button>
        <div class="dp-jump-menu dp-jump-menu--years" *ngIf="isJumpOpen('year', side)" role="listbox">
          <button type="button" class="dp-jump-option" *ngFor="let y of years" role="option" [attr.aria-selected]="y === year" [class.dp-jump-option--active]="y === year" (click)="pickYear(y, side)">
            {{ y }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #monthBody let-weeks="weeks">
    <div class="dp-weekdays" role="row">
      <span class="dp-weekday" role="columnheader" *ngFor="let weekday of weekdays">
        {{ weekday }}
      </span>
    </div>

    <div class="dp-grid" role="grid">
      <ng-container *ngFor="let week of weeks">
        <div class="dp-week" role="row">
          <ng-container *ngFor="let day of week">
            <button
              *ngIf="day; else blankCell"
              type="button"
              role="gridcell"
              class="dp-day"
              [class.dp-day--selected]="isSelected(day)"
              [class.dp-day--range-start]="isRangeStart(day)"
              [class.dp-day--range-end]="isRangeEnd(day)"
              [class.dp-day--in-range]="isInRange(day)"
              [class.dp-day--range-single]="isRangeSingle(day)"
              [class.dp-day--muted]="isOutsideRange(day)"
              [class.dp-day--dimmed]="isDisabled(day)"
              [class.dp-day--no-data]="isBeyondMax(day)"
              [disabled]="isDisabled(day)"
              [attr.aria-label]="dayAriaLabel(day)"
              [attr.aria-pressed]="isAriaSelected(day)"
              [attr.aria-selected]="isAriaSelected(day)"
              (click)="selectDay(day)"
            >
              <span class="dp-day-num">{{ day.day }}</span>
              <span class="dp-day-dot" *ngIf="hasDot(day)" aria-hidden="true"></span>
            </button>
            <ng-template #blankCell>
              <span class="dp-day dp-day--blank" aria-hidden="true"></span>
            </ng-template>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <div class="dp-footer">
    <span class="dp-footer-date">{{ footerLabel }}</span>
    <div class="dp-footer-actions">
      <button type="button" class="dp-clear" (click)="clearSelection()">Clear</button>
      <button type="button" class="dp-clear" (click)="resetSelection()">Reset</button>
      <button type="button" class="btn btn-sm btn-secondary text-white" [disabled]="isApplyDisabled" (click)="applySelection()">Apply</button>
    </div>
  </div>
</div>
